import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {withRouter} from "react-router-dom";
import { useMediaQuery } from "@material-ui/core";
import {PATH_CAR_LIST} from "constants/path";
import api, { getCarList } from "api";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import {commaNum} from "utils/func";
import Moment from 'moment';


const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 50,
    },
    card: {
        flex: 1,
    },
    image: {
        objectFit: 'cover',
    },
    title: {
        fontSize: 22,
        fontWeight: '500',
        display: 'block',
        marginTop: 12,
        color: '#090909',
    },
    subTitle: {
        fontSize: 16,
        fontWeight: '500',
        color: '#090909',
        display: 'block',
        marginTop: 4,
    },
});


export const CarList = () => {
    const theme = useTheme();

    const underXs = useMediaQuery(theme.breakpoints.down('xs'));
    const underSm = useMediaQuery(theme.breakpoints.down('sm'));

    const [cars, setCars] = useState([]);

    const [page, setPage] = useState(1);
    const [isEndReached, setEndReached] = useState(false);
    const [initialized, setInitialized] = useState(false);

    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState({gender: '남성', content: '', name: '', age: ''});

    const getData = () => {
        if (!isEndReached) {
            getCarList({page: page}).then((res) => {
                if (res.ok) {
                    console.log(res);
                    if (!res.data.next) {
                        setEndReached(true);
                    } else {
                        setPage(page + 1);
                    }
                    setCars([...cars, ...res.data.results]);
                }
            });
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        if (!initialized) {
            setInitialized(true);
            getData();
            fetchComments();
        }
        return () => window.removeEventListener("scroll", onScroll);
    }, [cars]);

    const onScroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight && initialized) {
            getData();
        }
    };

    const submitComment = () => {
        console.log(comment);
        if(!comment.content || !comment.name || !comment.gender || !comment.age){alert('모든 정보를 입력해주세요.'); return}
        api.post('v1/comments/', comment).then(res=>{
            fetchComments();
        })
    };

    const fetchComments = () => {
        api.get('v1/comments/').then(res=>{
            console.log(res);
            setComments(res.data.results);
        })
    };

    return (
        <div>
            <div style={{position: 'relative', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: underXs ? 'flex-start' : 'center', backgroundImage: `url(${require('assets/img/reserve_bg.png')})`, width: '100%', height: '100vh', maxHeight: underXs ? 480: null, backgroundSize: 'cover', backgroundPosition: `right ${underSm ? -100: 0}px center`}}>
                <div style={{position: 'absolute', bottom: underXs ? -40 :-48, left: 0, width: '100%', textAlign: 'center'}}>
                    <div style={{padding: underXs ? '6px 0 44px 0' : '10px 0 60px 0', backgroundColor: 'white', color: 'black', fontSize: underXs ? 18 : 24, width: underXs ? 180 : 347, margin: 'auto', borderRadius: 80}}>List</div>
                </div>
                <div style={{padding: `0 ${underXs ? 24 : 0}px`}}>
                    <h1 style={{fontSize: underSm ? (underXs ? 28 : 40) : 60, fontWeight: '700', color: 'white', display: 'block', textAlign: underXs ? 'left' : 'center', marginBottom: 24}}>차원이 다른 카셰어링, {underXs && <br/>} 클라스카</h1>
                    <span style={{fontSize: underSm ? (underXs ? 15 : 24) : 32, fontWeight: '500', color: underXs ? '#393939' : 'white', display: 'block', textAlign: underXs ? 'left' : 'center', marginBottom: underXs ? 100: 100,}}>내 주변의 차로 오늘의 클라스를 선택하세요</span>
                </div>
            </div>
            <div style={{height: underXs ? 52 : (underSm ? 60 : 90), backgroundColor: 'white'}}>

            </div>
            <div style={{padding: `0 ${underSm? (underXs ? 14 : 24) : 70}px`, backgroundColor: 'white'}}>
                <GridContainer style={{ backgroundColor: 'white',maxWidth: 1080, margin: 'auto',}}>
                    {
                        !underSm &&
                        <GridItem xs={12}>
                        <span style={{fontSize: 28, fontWeight: '700', color: '#090909', marginBottom: 60, display: 'block', marginLeft: '-60px'}}>
                            당신 근처에 이런 차들이 있어요.
                        </span>
                        </GridItem>
                    }
                    {
                        cars.map((e, i) => {
                            return (
                                <GridItem xs={12}
                                          sm={6}
                                          style={{padding: `0 ${underXs ? 0 : (underSm ? 14: 28)}px`}}
                                          key={e.id}>
                                    <CarItem car={e} />
                                    {
                                        i === cars.length - 1 &&
                                        <div style={{height: 50,}} />
                                    }
                                </GridItem>
                            )
                        })
                    }
                </GridContainer>
                <div style={{maxWidth: 1080, margin: '50px auto'}}>
                    {!underSm &&
                    <span style={{fontSize: 28, fontWeight: '700', color: '#090909', marginBottom: 20, display: 'block', marginLeft: '-60px'}}>
                        당신의 의견을 들려주세요.
                    </span>}
                    <div>
                        <div>
                            <span style={{marginRight: 15}}>이름: </span>
                            <input style={{marginRight: 15}} value={comment.name} onChange={({target})=>setComment(Object.assign({}, comment, {name: target.value}))}/>
                            {underSm && <br/>}
                            <span style={{marginRight: 15}}>나이: </span>
                            <input style={{marginRight: 15}} placeholder={'24'} value={comment.age} onChange={({target})=>setComment(Object.assign({}, comment, {age: target.value}))}/>
                            {underSm && <br/>}
                            <span style={{marginRight: 15}}>성별: </span>
                            <select
                                value={comment.gender}
                                onChange={(e)=>setComment(Object.assign({}, comment, {gender: e.target.value}))} style={{width: '150px'}}>
                                <option value={'남성'}>남성</option>
                                <option value={'여성'}>여성</option>
                            </select>
                        </div>
                        <textarea
                            value={comment.content}
                            onChange={(e)=>setComment(Object.assign({}, comment, {content: e.target.value}))}
                            style={{
                                width: '100%',
                                height: '170px',
                                marginTop: '15px',
                                borderRadius: '14px',
                                border: '1px solid #ccc',
                                backgroundColor: '#fafafa',
                                resize: 'none',
                                padding: '20px',
                                fontSize: '1rem',
                                fontWeight: '400',
                                lineHeight: '1.5',
                                color: '#495057',
                                '&:focus': {
                                    borderRadius: '14px',
                                }
                            }}/>
                            <div style={{textAlign: 'right'}}>
                                <button
                                    onClick={submitComment}
                                    style={{
                                        width: '128px',
                                        borderRadius: '38px',
                                        border: '1px solid #fc5356',
                                        color: '#fff',
                                        backgroundImage: 'linear-gradient(90deg,#ff2d00 4%,#ff6722)',
                                        padding: '4px 14px',
                                        fontFamily: 'AppleSDGothicNeo',
                                        fontSize: '17px',
                                        fontWeight: '800',
                                        lineHeight: '1.94em',
                                        textAlign: 'center',
                                        margin: '10px 10px',
                                        cursor: 'pointer',
                                    }}
                                >등록</button>
                            </div>
                    </div>
                    <div style={{paddingBottom: 30}}>
                        <h3>등록된 의견들</h3>
                        {comments.map((e, i)=>(
                            <div style={{padding: '20px 0', borderBottom: '1px solid #ccc'}}>
                                <div>
                                    {e.name}/ {e.age} / {e.gender} <span style={{fontSize: '12px', color: '#999'}}>{new Moment(e.createdAt).format('YYYY-MM-DD HH:SS')}</span>
                                </div>
                                <div>{e.content}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const _CarItem = (props) => {
    const theme = useTheme();

    const underXs = useMediaQuery(theme.breakpoints.down('xs'));
    const underSm = useMediaQuery(theme.breakpoints.down('sm'));

    const { car } = props;
    const classes = useStyles(props);

    return (
        <div className={classes.container}  onClick={() => {
            props.history.push(`/${PATH_CAR_LIST}/${car.id}`);
        }}>
            <div className={classes.image} style={{backgroundImage: `url(${car.images[0].image})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%',
                position: 'relative',
                // height: `${90 * 231 / 347}vw`,
                paddingBottom: '66.5%',
                borderRadius: 5}}>
                <div style={{padding: '5px 10px', backgroundColor: '#FFFFFF', borderRadius: 2, position: 'absolute', bottom: 8, right: 8,}}>
                    <span style={{fontWeight: '500', fontSize: underXs ? 16 : (underSm ? 18 : 20), color: '#090909'}}>{commaNum(car.charge_per_hour)}원</span>
                    <span style={{fontWeight: '500', fontSize: underXs ? 14 : (underSm ? 15 : 17), color: '#5d5d5d'}}>/시간당</span>
                </div>
            </div>
            <div style={{width: '100%', textAlign: 'left'}}>
                {/*<img className={classes.image} src={car.image} alt="car"/>*/}
                <span className={classes.title}>{car.name}</span>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span className={classes.subTitle}>{car.region}</span>
                    <span style={{color: car.status === '완료' ? '#C4C4C4' : '#0993D4', fontWeight: '500', fontSize: 18}}>{car.status === '완료' ? '예약완료' : '가능'}</span>
                </div>
            </div>
        </div>
    )
};

const CarItem = withRouter(_CarItem);
